var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.tenant
    ? _c(
        "v-container",
        { attrs: { "grid-list-md": "", "text-xs-center": "" } },
        [
          _c(
            "div",
            { staticClass: "grid text-xs-center" },
            [
              _c(
                "v-card",
                { staticClass: "profile" },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c("v-flex", { attrs: { md6: "", xs12: "" } }, [
                        _c("div", { staticClass: "profile_main" }, [
                          _c("div", { staticClass: "profile_main-info" }, [
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "grey--text text-lg-left text--darken-3 mt-3",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.tenant.firstName) +
                                    " " +
                                    _vm._s(_vm.tenant.lastName)
                                ),
                              ]
                            ),
                            _c(
                              "h4",
                              { staticClass: "grey--text text-lg-left" },
                              [_vm._v(_vm._s(_vm.tenant.email))]
                            ),
                          ]),
                        ]),
                      ]),
                      _c("v-divider", {
                        staticClass: "mx-3",
                        attrs: { inset: "", vertical: "" },
                      }),
                      _c("v-flex", { attrs: { md4: "", xs12: "" } }, [
                        _c("table", { staticClass: "tenant-info" }, [
                          _c("tr", [
                            _c("td", { staticClass: "lbl" }, [_vm._v("tel")]),
                            _c("td", { staticClass: "nfo" }, [
                              _vm._v(_vm._s(_vm.tenant.telephone)),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "lbl" }, [
                              _vm._v("nood tel"),
                            ]),
                            _c("td", { staticClass: "nfo" }, [
                              _vm._v(_vm._s(_vm.tenant.emergencyNumber)),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "lbl" }, [_vm._v("taal")]),
                            _c("td", { staticClass: "nfo" }, [
                              _vm._v(_vm._s(_vm.tenant.language)),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "lbl" }, [
                              _vm._v("cNummer"),
                            ]),
                            _c("td", { staticClass: "nfo" }, [
                              _vm._v(_vm._s(_vm.tenant.cNumber)),
                            ]),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "grid text-xs-center" },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { md4: "", xs12: "" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "tenant-card contract-list" },
                        _vm._l(_vm.contracts, function (contract) {
                          return _vm.contracts
                            ? _c(
                                "div",
                                {
                                  staticClass: "text-xs-left clickable-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.getPaymentInfo(contract)
                                    },
                                  },
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatDate")(contract.startDate)
                                      ) +
                                        " - " +
                                        _vm._s(
                                          _vm._f("formatDate")(contract.endDate)
                                        )
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(contract.unit.project.name) +
                                        ", " +
                                        _vm._s(contract.unit.name)
                                    ),
                                  ]),
                                ]
                              )
                            : _c("div", { staticClass: "text-xs-left" }, [
                                _vm._v("geen contracten gevonden"),
                              ])
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { md8: "", xs12: "" } },
                    [
                      _vm.selectedContract
                        ? _c(
                            "v-card",
                            {
                              staticClass: "tenant-card contract-payment-info",
                            },
                            [
                              _c("h6", [_vm._v("subscriptions")]),
                              _vm._l(
                                _vm.selectedContract.subscriptions,
                                function (subscription) {
                                  return _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(subscription.paymentType) +
                                        " "
                                    ),
                                  ])
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      )
    : _c(
        "v-container",
        { attrs: { "grid-list-md": "", "text-xs-center": "" } },
        [
          _c(
            "div",
            { staticClass: "grid text-xs-center" },
            [
              _c("v-card", { staticClass: "profile" }, [
                _vm._v(" Geen data gevonden "),
              ]),
            ],
            1
          ),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }